import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export function DeleteUserButton({ user, onDone }) {
  const del = async () => {
    try {
      await api.delete(`/admin/users/${user.id}`);
      toast.success(`${user.name} eliminato`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button size="sm" variant="outline" className="border-destructive/40 text-destructive hover:bg-destructive hover:text-destructive-foreground" data-testid={`employee-delete-button-${user.id}`}>
            <Trash2 className="mr-1.5 h-3.5 w-3.5" />Elimina
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Eliminare {user.name}?</AlertDialogTitle>
            <AlertDialogDescription>L'account verrà eliminato definitivamente insieme a ferie, permessi, malattie, notifiche e allegati. L'operazione non si può annullare.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="employee-delete-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={del} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="employee-delete-confirm">Elimina</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </span>
  );
}
